/* pi-accordion.js — reusable collapsible custom elements ================= */
(function () {
  if (!window.customElements.get('pi-accordion')) {
    class PiAccordion extends HTMLElement {
      static get observedAttributes() {
        return ['open'];
      }

      connectedCallback() {
        if (this._bound) return;
        this._bound = true;

        this.trigger = this.querySelector('[data-pi-acc-trigger]');
        this.panel = this.querySelector('[data-pi-acc-panel]');

        if (!this.trigger || !this.panel) return;

        const panelId = this.panel.id || `pi-acc-panel-${Math.random().toString(36).slice(2, 9)}`;
        this.panel.id = panelId;
        this.trigger.setAttribute('aria-controls', panelId);

        this.syncAria();

        this.onTriggerClick = (event) => {
          event.preventDefault();
          this.toggle();
        };

        this.trigger.addEventListener('click', this.onTriggerClick);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onTriggerClick);
        this._bound = false;
      }

      attributeChangedCallback(name) {
        if (name !== 'open') return;
        this.syncAria();
      }

      get open() {
        return this.hasAttribute('open');
      }

      set open(value) {
        if (value) this.setAttribute('open', '');
        else this.removeAttribute('open');
      }

      syncAria() {
        if (!this.trigger) return;
        this.trigger.setAttribute('aria-expanded', this.open ? 'true' : 'false');
      }

      toggle() {
        const next = !this.open;
        this.dispatchEvent(
          new CustomEvent('pi-accordion:toggle', {
            bubbles: true,
            detail: { open: next, accordion: this },
          })
        );

        if (next) this.open = true;
        else this.open = false;
      }

      show() {
        this.open = true;
      }

      hide() {
        this.open = false;
      }
    }

    window.customElements.define('pi-accordion', PiAccordion);
  }

  if (!window.customElements.get('pi-accordion-group')) {
    class PiAccordionGroup extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;

        this.single = this.hasAttribute('single');
        this.openFirst = this.hasAttribute('open-first');

        this.onToggle = (event) => {
          if (!this.single || !event.detail?.open) return;

          this.querySelectorAll('pi-accordion[open]').forEach((item) => {
            if (item !== event.detail.accordion) item.hide();
          });
        };

        this.addEventListener('pi-accordion:toggle', this.onToggle);

        if (this.openFirst) {
          const first = this.querySelector('pi-accordion');
          if (first && !this.querySelector('pi-accordion[open]')) first.show();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('pi-accordion:toggle', this.onToggle);
        this._bound = false;
      }
    }

    window.customElements.define('pi-accordion-group', PiAccordionGroup);
  }
})();
